export const INPUT_TYPE_SELECT = 'select';
export const INPUT_TYPE_INTEGER = 'integer';
export const INPUT_TYPE_QUANTITY = 'quantity';

export const INPUT_INTEGER_SELECT = 'integer-input-select'
export const INPUT_DATE_TIME = 'date_time';

export const INPUT_TYPE_TEXT = 'text';
export const INPUT_TYPE_CHECKBOX = 'checkbox';
export const INPUT_TYPE_RADIO = 'radio';
export const INPUT_TYPE_DATE = 'date';

